export default __webpack_public_path__ + "media/zurb/img/events/wired/pie-ranch/pie-ranch-photos-027cb9f139c72d26cb8ee74e9ec45e45.png";